export default __webpack_public_path__ + "static/media/Leaderboards.3884e9b4.svg";